import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

App.addListener("backButton", ({ canGoBack }) => {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    App.exitApp(); // Solo si no hay historial
  }
});

if (Capacitor.getPlatform() === "ios" && Capacitor.isNativePlatform()) {
  if (window.history.length > 1) {
    document.querySelector("body")?.classList.add("is-ios-app");
  }
}
console.log(Capacitor.isNativePlatform());
if (Capacitor.isNativePlatform()) {
  var className = "is-android";
  if (Capacitor.getPlatform() === "ios") {
    className = "is-ios";
  }
  document.querySelector("body")?.classList.add(className);
} else {
  document.querySelector("body")?.classList.add("is-web");
}
